import { Account } from 'entities/user/module'

import { preparePhoneNumber } from 'shared/lib/prepare-phone-number'

export function prepareCustomerData(account: Account | null) {
  return {
    email: account?.email,
    first_name: account?.first_name,
    last_name: account?.last_name,
    phone: preparePhoneNumber(account?.phone_number),
  }
}
